import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import XIcon from '@mui/icons-material/X';

const quickLinks = [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'FAQ', href: '/faq' },
    { label: 'Contact', href: '/contact' },
];

const policyLinks = [
    { label: 'Terms of Service', href: '/terms-of-service' },
    { label: 'Privacy Policy', href: '/privacy-policy' },
    { label: 'Refund Policy', href: '/refund-policy' },
    { label: 'Cookie Policy', href: '/cookie-policy' },
    { label: 'Disclaimer', href: '/disclaimer' },
    { label: 'Subscription Agreement', href: '/subscription-agreement' },
    { label: 'Acceptable Use Policy', href: '/acceptable-use-policy' },
    { label: 'Accessibility Statement', href: '/accessibility-statement' },
];

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                bgcolor: 'custom.surface.subtle',
                borderTop: t => `1px solid ${t.palette.custom.border.subtle}`,
                color: 'text.secondary',
                py: 8,
                mt: 8,
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={6}>
                    <Grid item xs={12} sm={4}>
                        <Typography variant="h5" sx={{ color: 'text.primary', mb: 2 }}>
                            Capitol Gains
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 320, lineHeight: 1.6 }}>
                            Transparency on stock trading activities by U.S. Congress members.
                        </Typography>
                    </Grid>

                    <Grid item xs={6} sm={4}>
                        <Typography variant="overline" sx={{ color: 'text.muted', display: 'block', mb: 1.5 }}>
                            Product
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            {quickLinks.map(({ label, href }) => (
                                <Link
                                    key={label}
                                    href={href}
                                    sx={{
                                        color: 'text.secondary',
                                        textDecoration: 'none',
                                        fontSize: '0.875rem',
                                        width: 'fit-content',
                                        '&:hover': { color: 'text.primary' },
                                    }}
                                >
                                    {label}
                                </Link>
                            ))}
                        </Box>
                    </Grid>

                    <Grid item xs={6} sm={4}>
                        <Typography variant="overline" sx={{ color: 'text.muted', display: 'block', mb: 1.5 }}>
                            Connect
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                            <IconButton
                                href="https://x.com/capitolgains_io"
                                target="_blank"
                                rel="noopener"
                                aria-label="Follow us on X"
                                size="small"
                                sx={{
                                    color: 'text.secondary',
                                    border: t => `1px solid ${t.palette.custom.border.subtle}`,
                                    borderRadius: 1,
                                    '&:hover': {
                                        color: 'text.primary',
                                        borderColor: t => t.palette.custom.border.strong,
                                    },
                                }}
                            >
                                <XIcon fontSize="small" />
                            </IconButton>
                            <Link
                                href="/contact"
                                sx={{
                                    px: 1.5,
                                    py: 0.75,
                                    fontSize: '0.8125rem',
                                    color: 'text.secondary',
                                    textDecoration: 'none',
                                    border: t => `1px solid ${t.palette.custom.border.subtle}`,
                                    borderRadius: 1,
                                    '&:hover': {
                                        color: 'text.primary',
                                        borderColor: t => t.palette.custom.border.strong,
                                    },
                                }}
                            >
                                Contact us →
                            </Link>
                        </Box>
                    </Grid>
                </Grid>

                <Box sx={{
                    mt: 6,
                    pt: 4,
                    borderTop: t => `1px solid ${t.palette.custom.border.subtle}`,
                }}>
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        {policyLinks.map(({ label, href }) => (
                            <Grid item key={label}>
                                <Link
                                    href={href}
                                    sx={{
                                        color: 'text.muted',
                                        textDecoration: 'none',
                                        fontSize: '0.75rem',
                                        '&:hover': { color: 'text.secondary' },
                                    }}
                                >
                                    {label}
                                </Link>
                            </Grid>
                        ))}
                    </Grid>

                    <Typography variant="caption" sx={{ color: 'text.muted' }}>
                        © {new Date().getFullYear()} Capitol Gains · All rights reserved.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
